import React from "react";

// nodejs library to set properties for components
// @material-ui/core components
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

// core components

import styles from "assets/jss/hwblog/components/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Info(props) {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.infoText}>
      {children}
    </div>
  );
}

Info.propTypes = {
  children: PropTypes.node
};
